import { Injectable } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { LocalStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class EquineService {
  constructor(
    private sharedService: SharedService, 
    private sessionSt: LocalStorageService
  ) {}

  public convertToPolicy(data: any): Observable<any> {
    return this.sharedService.postAPI('equine/convert-to-policy', data);
  }

  // Get All Static Data
  public getStaticData(): Observable<any> {
    return this.sharedService.getAPI('equine/static-data');
  }

  // Get Equine Data
  public getEquineData(
    id: string,
    options?: { previewType?: number; effectiveDate?: string }
  ): Observable<any> {
    let path = 'equine/quote/' + id;
    const params: string[] = [];
    if (options?.previewType != null) {
      params.push('preview_type=' + encodeURIComponent(String(options.previewType)));
    }
    if (options?.effectiveDate) {
      params.push('effective_date=' + encodeURIComponent(options.effectiveDate));
    }
    if (params.length) {
      path += '?' + params.join('&');
    }
    return this.sharedService.getAPI(path);
  }

  // Save Quote
  public saveQuote(data: any): Observable<any> {
    return this.sharedService.postAPI('equine/quote', data);
  }

  // Get Quote Details
  public getQuoteDetails(id: string): Observable<any> {
    return this.sharedService.getAPI('equine/quote/' + id);
  }

  // Get Quote Details By Quote ID
  public getQuoteDetailsByQuoteID(id: string): Observable<any> {
    return this.sharedService.getAPI('equine/quote/' + id);
  }

  /** Get documents for quote (doc_type: 1 = quote, 2 = policy) */
  public getDocuments(quoteId: string, docType: number = 1): Observable<any> {
    return this.sharedService.getAPI('equine/documents/' + quoteId + '/' + docType);
  }

  public getClassActivities(classId:string): Observable<any> {
    return this.sharedService.getAPI('equine/static-data/class-of-use/' + classId);
  }

  /** Get statement of facts for equine by cover type. Pass isMort=1 for ACE cover with Loss of Horse selected. */
  public getStatementOfFactsByCoverType(coverTypeId?: string, isMort?: number): Observable<any> {
    let path = 'equine/static-data/sof';
    if (coverTypeId) {
      path += '/' + encodeURIComponent(coverTypeId);
      if (isMort === 1) {
        path += '/1';
      }
    }
    return this.sharedService.getAPI(path);
  }

  /** Get options for the given cover type (e.g. blood stock options when Bloodstock cover is selected). */
  public getCoverTypeOptions(coverTypeId: string): Observable<any> {
    return this.sharedService.getAPI('equine/static-data/cover-types/' + encodeURIComponent(coverTypeId));
  }

  /** Get vet fee details (vet_fee, excess, addons) for a vet fee cover type (1 = Enhanced, 2 = Essential). */
  public getVetFeeDetails(vetFeeTypeId: string | number): Observable<any> {
    return this.sharedService.getAPI('equine/static-data/vet-fee/' + encodeURIComponent(String(vetFeeTypeId)));
  }

  /*
  * Create Quote Object for Save API
  */
  createQuoteObj(data) {
    return {
      data: {
        type: 'equine/quote',
        attributes: {
          declaration: true,
          proposer: data.proposer,
        },
      }
    };
  }

  /*
  * Issue The Quote
  */
  public issueQuote(data: any): Observable<any> {
    return this.sharedService.postAPI('equine/convert-to-policy', data);
  }

  public getAgreedQuestions(productId: string, agreedQuestionVersion = 1): Observable<any> {
    return this.sharedService.getAPI('staticdata/agreed_questions/' + productId + '/' + agreedQuestionVersion);
  }

  /** Get claim types for dropdown. type: 1 = Proposed Horse, 2 = Other Horses (includes Mortality). */
  public getClaimTypes(type: number): Observable<any> {
    return this.sharedService.getAPI('equine/claim/types/' + type);
  }

  public regenerateDocument(quoteId: string): Observable<any> {
    return this.sharedService.getAPI('equine/regenerate-doc/' + encodeURIComponent(quoteId));
  }

  /** Get cancellation refund amount for a policy (preview). effectiveDate: YYYY-MM-DD */
  public getCancellationRefund(policyId: string, effectiveDate: string): Observable<any> {
    const params = effectiveDate ? `?policy_id=${encodeURIComponent(policyId)}&effective_date=${encodeURIComponent(effectiveDate)}` : `?policy_id=${encodeURIComponent(policyId)}`;
    return this.sharedService.getAPI('equine/cancellation-refund' + params);
  }
  // get referral reasons for quote
  public getReferralReasons(quoteId: string): Observable<any>{
    return this.sharedService.getAPI(`quote/referral-reasons/list/${quoteId}`);
  }

  public getLatestReferralReasons(quoteId: string): Observable<any>{ 
    return this.sharedService.getAPI(`quote/latest-referral-reason/${quoteId}`);
  }

  public getQuoteReferralReasons(quoteId: string): Observable<any>{ 
    return this.sharedService.getAPI(`quote/referral-reasons/concatenated/${quoteId}`);
  }
}
